import { ImageLoader, ImageLoaderConfig } from '@angular/common';

// The origin of the CDN we are going to use to pull images from.
const base = 'https://images.ctfassets.net/';

export const myCustomLoader: ImageLoader = (config: ImageLoaderConfig) => {
    // Join the value that the user put in the `ngSrc` attribute and the CDN base into a single URL.
    const url = new URL(config.src, base);

    if (config.width) {
        url.searchParams.set('w', config.width.toString());
    }

    if (config.loaderParams?.['compression']) {
        url.searchParams.set('q', config.loaderParams['compression']);
    }

    return url.toString();
};